import React, { useState, useEffect } from 'react';

import { Items, Item, BorderedDetail } from './styles.js';

import { ContainerItem } from '../styles';

export default function MobileVersion({
  routesLapidar,
  handleSelect,
  selected,
  lapidar,
  HistoryIcon,
  routes,
  verifyRoles,
  loadingLapidar,
  roles,
  ...props
}) {
  const [indexActivatedItem, setIndexActivatedItem] = useState(0);

  useEffect(() => {
    const currentPath = window.location.pathname;
    let indexItem = 0;
    if (
      currentPath.includes('lapidar') &&
      currentPath !== 'lapidar/inscricao'
    ) {
      indexItem = routesLapidar.findIndex(item => item.title === selected);
    } else {
      indexItem = routes.findIndex(item => item.title === selected);
    }
    setIndexActivatedItem(indexItem);
  }, []);

  return (
    <>
      <BorderedDetail
        selected={selected}
        lapidar={window.location.pathname.slice(0, 8) === '/lapidar'}
      >
        <div />
      </BorderedDetail>
      <Items>
        {window.location.pathname.indexOf('/lapidar') === 0 &&
        window.location.pathname !== 'lapidar/inscricao' ? (
          <>
            {routesLapidar.map(function (object, i) {
              return (
                <Item
                  key={i}
                  selected={selected === object.title ? true : false}
                  onClick={() => handleSelect(object)}
                  onlyDesktopItem={object.onlyDesktopItem}
                  disabled={object.disabled}
                  challengeSize={object.title}
                  next={i === indexActivatedItem + 1}
                  previous={i === indexActivatedItem - 1}
                >
                  <ContainerItem
                    selected={selected === object.title ? true : false}
                    desafios={object.title === 'Histórico de Desafios'}
                    objectDisabled={object.disabled}
                  >
                    {object.title === 'Histórico de Avaliações' &&
                    selected === object.title ? (
                      <img
                        src={HistoryIcon}
                        width={'35px'}
                        alt={object.title}
                        className={object.path.replace('/', '')}
                      />
                    ) : (
                      <img
                        src={
                          props.menuSelected === object.title
                            ? object.selectedIcon
                            : object.icon
                        }
                        width={'35px'}
                        alt={object.title}
                        className={object.path.replace('/', '')}
                      />
                    )}
                    <span>{object.title}</span>
                  </ContainerItem>
                </Item>
              );
            })}
          </>
        ) : (
          <>
            {routes.map(function (object, i) {
              return (
                <>
                  {object.title === 'Desafio Lapidar' ? (
                    <>
                      {loadingLapidar ? (
                        <Item
                          key={i}
                          selected={selected === object.title ? true : false}
                          onlyDesktopItem={object.onlyDesktopItem}
                          disabled={true}
                          challengeSize={object.title}
                          titleStore={object.title}
                          next={i === indexActivatedItem + 1}
                          previous={i === indexActivatedItem - 1}
                        >
                          <div className={object.path.replace('/', '')}>
                            <img
                              src={
                                props.menuSelected === object.title
                                  ? object.selectedIcon
                                  : object.icon
                              }
                              width={
                                object.title === 'Desafio Lapidar'
                                  ? '50px'
                                  : '35px'
                              }
                              alt={object.title}
                              className="lapidar"
                            />
                            <span
                              style={
                                object.title === 'Desafio Lapidar'
                                  ? { marginTop: '-6px' }
                                  : { marginTop: '0px' }
                              }
                            >
                              {object.title}
                            </span>
                          </div>
                        </Item>
                      ) : (
                        <Item
                          key={i}
                          selected={selected === object.title ? true : false}
                          onClick={(e) => {
                            e.preventDefault();
                            if (verifyRoles(roles, 'DESAFIO_LAPIDAR') === true) {
                              handleSelect(object)
                            }
                          }}
                          onlyDesktopItem={object.onlyDesktopItem}
                          disabled={
                            object.title === 'Desafio Lapidar'
                              ? verifyRoles(roles, 'DESAFIO_LAPIDAR') === false
                                ? true
                                : object.disabled
                              : object.disabled
                          }
                          challengeSize={object.title}
                          titleStore={object.title}
                          next={i === indexActivatedItem + 1}
                          previous={i === indexActivatedItem - 1}
                        >
                          <div className="lapidar">
                            <img
                              src={
                                props.menuSelected === object.title
                                  ? object.selectedIcon
                                  : object.icon
                              }
                              width={
                                object.title === 'Desafio Lapidar'
                                  ? '50px'
                                  : '35px'
                              }
                              alt={object.title}
                              className="lapidar"
                            />
                            <span>{object.title}</span>
                          </div>
                        </Item>
                      )}
                    </>
                  ) : (
                    <Item
                      key={i}
                      selected={selected === object.title ? true : false}
                      onClick={() => handleSelect(object)}
                      onlyDesktopItem={object.onlyDesktopItem}
                      disabled={
                        object.title === 'Desafio Lapidar'
                          ? verifyRoles(roles, 'DESAFIO_LAPIDAR') === false
                            ? true
                            : object.disabled
                          : object.disabled
                      }
                      titleStore={object.title}
                      className={
                        object.title === 'Minha colocação' && 'colocacao'
                      }
                      next={i === indexActivatedItem + 1}
                      previous={i === indexActivatedItem - 1}
                    >
                      <div>
                        <img
                          src={
                            props.menuSelected === object.title
                              ? object.selectedIcon
                              : object.icon
                          }
                          width={
                            object.title === 'Desafio Lapidar' ? '50px' : '35px'
                          }
                          alt={object.title}
                          className={object.path.replace('/', '')}
                        />
                        <span>{object.title}</span>
                      </div>
                    </Item>
                  )}
                </>
              );
            })}
          </>
        )}
      </Items>
    </>
  );
}
